  (function () {
    'use strict';

    /* ─────────────────────────────
     CONFIG
  ───────────────────────────── */
  var API_BASE    = 'https://api.flitesports.com/api/v1/bundle';
  var IMAGE_BASE  = 'https://api.flitesports.com/storage/';
    var root = document.getElementById('custom-options-root');
    var productId = root ? root.dataset.productId : null;

    if (!root || !productId) return;

    /* ─────────────────────────────
     SKELETON while loading
  ───────────────────────────── */
    function showSkeleton() {
      root.style.display = 'block';
      var html = '<div class="flite-skeleton">';
      for (var i = 0; i < 3; i++) {
        html +=
          '<div class="flite-skeleton-item">' +
          '<div class="flite-skeleton-label"></div>' +
          '<div class="flite-skeleton-field"></div>' +
          '</div>';
      }
      html += '</div>';
      root.innerHTML = html;
    }

    /* ─────────────────────────────
     STRIP PROGRAM PREFIX
     Removes everything up to and including the last word before
     a known product-type keyword, e.g.:
     "RAKESH PROGRAM COTTON-BLEND TSHIRT (BLACK)"
     → "COTTON-BLEND TSHIRT (BLACK)"
  ───────────────────────────── */
    var PROGRAM_PREFIX_RE = /^.+?\bPROGRAM\s+/i;

    function cleanTitle(raw) {
      return (raw || '').replace(PROGRAM_PREFIX_RE, '').trim();
    }

    /* ─────────────────────────────
     HELPERS
  ───────────────────────────── */
    function el(tag, attrs, children) {
      var node = document.createElement(tag);
      if (attrs) {
        Object.keys(attrs).forEach(function (k) {
          if (k === 'className') {
            node.className = attrs[k];
          } else if (k === 'innerHTML') {
            node.innerHTML = attrs[k];
          } else {
            node.setAttribute(k, attrs[k]);
          }
        });
      }
      if (children) {
        children.forEach(function (c) {
          if (c) node.appendChild(c);
        });
      }
      return node;
    }

    function text(str) {
      return document.createTextNode(str);
    }

    /* ─────────────────────────────
     PARSE bundle_options for
     required flags & placeholders
  ───────────────────────────── */
    function parseStaticOptions(bundle_options) {
      /*
      Returns a map keyed by normalised option_name:
      { "PLAYER REGISTRATION NAME": { required: true, placeholder: "..." },
        "PLAYER #":                 { required: true, placeholder: "..." } }
    */
      var map = {};
      if (!Array.isArray(bundle_options)) return map;
      bundle_options.forEach(function (opt) {
        if (!opt.option_name) return;
        map[opt.option_name.toUpperCase().trim()] = {
          required: opt.option_required === '1' || opt.option_required === 1,
          placeholder: opt.option_placeholder || '',
        };
      });
      return map;
    }

    /* ─────────────────────────────
     VALIDATION
  ───────────────────────────── */
    function isBlank(field) {
      return field.tagName === 'SELECT' ? field.value === '' : field.value.trim() === '';
    }

    function markErr(group) {
      var f = group.querySelector('.flite-input, .flite-select');
      var m = group.querySelector('.flite-error-msg');
      if (f) f.classList.add('has-error');
      if (m) m.classList.add('visible');
    }

    function clearErr(group) {
      var f = group.querySelector('.flite-input, .flite-select');
      var m = group.querySelector('.flite-error-msg');
      if (f) f.classList.remove('has-error');
      if (m) m.classList.remove('visible');
    }

    function validateAll() {
      var groups = root.querySelectorAll('.flite-option-group[data-required="true"]');
      var allValid = true;
      var first = null;

      groups.forEach(function (g) {
        var f = g.querySelector('.flite-input, .flite-select');
        if (!f) return;
        if (isBlank(f)) {
          markErr(g);
          allValid = false;
          if (!first) first = g;
        } else {
          clearErr(g);
        }
      });

      if (!allValid && first) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var bad = first.querySelector('.flite-input, .flite-select');
        if (bad)
          setTimeout(function () {
            bad.focus({ preventScroll: true });
          }, 350);
      }
      return allValid;
    }

    /* ─────────────────────────────
     COLLECT PROPERTIES
  ───────────────────────────── */
    function collectProperties() {
        var props = {};

        root.querySelectorAll('.flite-option-group').forEach(function (g) {
            var f = g.querySelector('.flite-input, .flite-select');
            if (!f) return;

            var m = (f.name || '').match(/properties\[(.+)\]/);

            if (m && f.value.trim()) {
                props[m[1].toUpperCase()] = f.value.trim().toUpperCase();
            }
        });

        return props;
    }
    /* ─────────────────────────────
     SIZE CHART MODAL
  ───────────────────────────── */
    var modal = null;

    function buildModal() {
      if (modal) return;
      var overlay = el('div', { className: 'flite-modal-overlay', id: 'flite-modal' });
      var box = el('div', { className: 'flite-modal' });
      var closeBtn = el('button', { className: 'flite-modal-close', type: 'button', innerHTML: '&times;' });
      var title = el('div', { className: 'flite-modal-title' }, [text('Size Chart')]);
      var img = el('img', { id: 'flite-modal-img', src: '', alt: 'Size Chart' });

      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
      });

      box.appendChild(closeBtn);
      box.appendChild(title);
      box.appendChild(img);
      overlay.appendChild(box);
      document.body.appendChild(overlay);
      modal = overlay;
    }

    function openModal(imgSrc, titleText) {
      if (!modal) buildModal();
      modal.querySelector('#flite-modal-img').src = imgSrc;
      modal.querySelector('.flite-modal-title').textContent = titleText || 'Size Chart';
      modal.classList.add('open');
    }

    function closeModal() {
      if (modal) modal.classList.remove('open');
    }

    /* ─────────────────────────────
     BUILD OPTION GROUP
  ───────────────────────────── */
    function buildGroup(opts) {
      var group = el('div', {
        className: 'flite-option-group',
        'data-required': opts.required ? 'true' : 'false',
      });

      /* Label row */
      var labelEl = el('label', { className: 'flite-label', for: 'flite-' + opts.fieldName });
      labelEl.appendChild(text(opts.label));
      if (opts.required) {
        labelEl.appendChild(el('span', { className: 'flite-required' }, [text(' *')]));
      }
      if (opts.sizeImage) {
        var chartLink = el('span', { className: 'flite-size-chart-link' }, [text('Size Chart')]);
        var imgSrc = opts.sizeImage;
        var imgTitle = opts.sizeTitle && opts.sizeTitle !== 'SIZE TITLE' ? opts.sizeTitle : opts.label + ' Size Chart';
        chartLink.addEventListener('click', function () {
          openModal(imgSrc, imgTitle);
        });
        labelEl.appendChild(chartLink);
      }
      group.appendChild(labelEl);

      /* Field */
      if (opts.type === 'text') {
        var input = el('input', {
          type: 'text',
          id: 'flite-' + opts.fieldName,
          name: 'properties[' + opts.fieldName + ']',
          className: 'flite-input',
          placeholder: opts.placeholder || '',
          autocomplete: 'off',
        });
        if (opts.prefill) input.value = opts.prefill;

        /* Auto-uppercase */
        input.addEventListener('input', function () {
          var pos = this.selectionStart;
          this.value = this.value.toUpperCase();
          this.setSelectionRange(pos, pos);
        });

        /* INITIALS: max 2 chars, letters A-Z only */
        if (opts.initialsOnly) {
          input.setAttribute('maxlength', '2');
          input.addEventListener('input', function () {
            this.value = this.value.replace(/[^A-Z]/g, '').slice(0, 2);
          });
        }

        input.addEventListener('input', function () {
          if (input.value.trim()) clearErr(group);
        });

        input.addEventListener('input', function () {
          if (input.value.trim()) clearErr(group);
        });

        group.appendChild(input);
      } else {
        var select = el('select', {
          id: 'flite-' + opts.fieldName,
          name: 'properties[' + opts.fieldName + ']',
          className: 'flite-select',
        });

        select.appendChild(el('option', { value: '' }, [text('-- Please choose --')]));

        if (opts.optgroups && opts.optgroups.length) {
          opts.optgroups.forEach(function (og) {
            var grpEl = el('optgroup', { label: og.label });
            og.items.forEach(function (val) {
              var opt = el('option', { value: val }, [text(val)]);
              grpEl.appendChild(opt);
            });
            select.appendChild(grpEl);
          });
        } else if (opts.options && opts.options.length) {
          opts.options.forEach(function (val) {
            var opt = el('option', { value: val }, [text(val)]);
            select.appendChild(opt);
          });
        }

        /* Preselect — exact then partial */
        if (opts.prefill != null && opts.prefill !== '') {
          var found = false;
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].value === String(opts.prefill)) {
              select.selectedIndex = i;
              found = true;
              break;
            }
          }
          if (!found) {
            for (var j = 0; j < select.options.length; j++) {
              if (select.options[j].value.indexOf(String(opts.prefill)) !== -1) {
                select.selectedIndex = j;
                break;
              }
            }
          }
        }

        select.addEventListener('change', function () {
          if (select.value) clearErr(group);
        });

        group.appendChild(select);
      }

      /* Error message */
      var errMsg = el('span', { className: 'flite-error-msg' }, [text('This is a required field.')]);
      group.appendChild(errMsg);

      return group;
    }

    /* ─────────────────────────────
     BUILD PLAYER # SELECT
     00-99 + BLANK option
  ───────────────────────────── */
    function buildPlayerNumberSelect(preselect, required) {
      var group = el('div', {
        className: 'flite-option-group',
        'data-required': required ? 'true' : 'false',
      });

      var labelEl = el(
        'label',
        {
          className: 'flite-label',
          for: 'flite-PLAYER_NUMBER',
        },
        [text('PLAYER #')]
      );
      if (required) {
        labelEl.appendChild(el('span', { className: 'flite-required' }, [text(' *')]));
      }
      group.appendChild(labelEl);

      var select = el('select', {
        id: 'flite-PLAYER_NUMBER',
        name: 'properties[PLAYER #]',
        className: 'flite-select',
      });

      select.appendChild(el('option', { value: '' }, [text('-- Please choose --')]));
      select.appendChild(el('option', { value: 'BLANK-NO PLAYER #' }, [text('BLANK – NO PLAYER #')]));

      var nums = ['00', '0'];
      for (var n = 1; n <= 99; n++) nums.push(String(n));
      nums.forEach(function (num) {
        select.appendChild(el('option', { value: num }, [text(num)]));
      });

      /* Preselect from API value */
      if (preselect != null && preselect !== '') {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === String(preselect)) {
            select.selectedIndex = i;
            break;
          }
        }
      }

      select.addEventListener('change', function () {
        if (select.value) clearErr(group);
      });

      group.appendChild(select);
      group.appendChild(el('span', { className: 'flite-error-msg' }, [text('This is a required field.')]));

      return group;
    }

    /* ─────────────────────────────
     RENDER FROM API RESPONSE
   ───────────────────────────── */
    function render(body) {
      var box = el('div', { className: 'flite-options-box' });
      var staticOptions = parseStaticOptions(body.bundle_options);

      /* ── 1 & 2. All text/select fields from bundle_options (except PLAYER #) ──
        Renders in the exact order returned by the API.
        Prefill is looked up from body using snake_case key convention. */
      if (Array.isArray(body.bundle_options)) {
        body.bundle_options.forEach(function (opt) {
          var key = (opt.option_name || '').toUpperCase().trim();
          if (!key || key === 'PLAYER #') return; // PLAYER # handled separately
          if (!opt.option_required || opt.option_required === '0' || opt.option_required === 0) {
            return;
          }
          // Convert "JERSEY NAME" → "jersey_name", "PLAYER REGISTRATION NAME" → "registered_player_name"
          var bodyKey =
          key === 'PLAYER REGISTRATION NAME' ? 'registered_player_name' : key.toLowerCase().replace(/\s+/g, '_');

          var prefillVal = body.hasOwnProperty(bodyKey) ? body[bodyKey] || '' : '';
          var placeholder = opt.option_placeholder || '';
          if (prefillVal === placeholder) prefillVal = '';

          // INITIALS: force required + fixed placeholder text
          if (key === 'INITIALS') {
            placeholder = '2 CHARACTERS ONLY, CAPITAL LETTERS A-Z (E.G. AA, GH, DF)';
          }

          box.appendChild(
            buildGroup({
              label: key,
              fieldName: key,
              required: opt.option_required === '1' || opt.option_required === 1,
              type: 'text',
              placeholder: placeholder,
              prefill: prefillVal,
              initialsOnly: key === 'INITIALS',
            })
          );
        });
      }

      /* ── 3. Player Number ──
        Show when "PLAYER #" exists in bundle_options. */
      var playerNumOpt =
        Array.isArray(body.bundle_options) &&
        body.bundle_options.find(function (o) {
          return (o.option_name || '').toUpperCase().trim() === 'PLAYER #';
        });

      if (playerNumOpt) {
        var pnRequired = playerNumOpt.option_required === '1' || playerNumOpt.option_required === 1;
        /* ── ONLY RENDER IF REQUIRED ── */
        if (pnRequired) {
          box.appendChild(buildPlayerNumberSelect(body.player_number, pnRequired));
        }
      }

      /* ── 4. Dynamic product size dropdowns ── */
      if (Array.isArray(body.products)) {
        var seen = {};

        body.products.forEach(function (prod) {
          var product = prod.store_product;
          if (!product || !product.title) return;

          /* Quantity suffix based on product type */
          var qty = prod.bundle_item_quantity || prod.quantity || 2;
          var pType = (product.product_type || '').trim();
          var suffix = '';

          if (qty != 1) {
              if (pType === 'Soccer Jersey') {
                  suffix = ' *' + qty + '-JERSEYS';
              } else {
                  // Soccer Socks and other non-jersey items
                  suffix = ' *' + qty + '-PAIRS';
              }
          }

          var displayTitle = cleanTitle(product.title).toUpperCase() + suffix.toUpperCase();
          var titleKey = displayTitle.toUpperCase();

          if (seen[titleKey]) return;
          seen[titleKey] = true;

          (prod.options || []).forEach(function (optBlock, idx) {
            var sizes = optBlock.bundle_product_size || [];

            // Move SOCKS - TODDLER to the first option.
            // Keep the relative order of all other options unchanged.
            sizes = sizes.slice();

            var toddlerIndex = sizes.findIndex(function (size) {
              return size.trim().toUpperCase() === 'SOCKS - TODDLER';
            });

            if (toddlerIndex > 0) {
              var toddlerOption = sizes.splice(toddlerIndex, 1)[0];
              sizes.unshift(toddlerOption);
            }

            /* Split into category optgroups (Toddler/Youth/Boys/Women/Men/Adult) when 2+ are present */
            var categories = [
              { key: 'TODDLER', label: '── Toddler ──' },
              { key: 'YOUTH',   label: '── Youth ──' },
              { key: 'GIRLS',   label: '── Girls ──' },
              { key: 'BOYS',    label: '── Boys ──' },
              { key: 'WOMEN',   label: '── Women ──' },
              { key: 'MEN',     label: '── Men ──' },
              { key: 'ADULT',   label: '── Adult ──' },
            ];

            var matched = {};
            var usedSizes = {};

            categories.forEach(function (cat) {
              matched[cat.key] = sizes.filter(function (s) {
                return s.indexOf(cat.key) === 0;
              });
              matched[cat.key].forEach(function (s) {
                usedSizes[s] = true;
              });
            });

            var otherSizes = sizes.filter(function (s) {
              return !usedSizes[s];
            });

            var populatedCategories = categories.filter(function (cat) {
              return matched[cat.key].length > 0;
            });

            var optgroups = null;
            var flatOpts = null;

            if (populatedCategories.length > 1) {
              optgroups = populatedCategories.map(function (cat) {
                return { label: cat.label, items: matched[cat.key] };
              });
              if (otherSizes.length) optgroups.push({ label: '── Other ──', items: otherSizes });
            } else {
              flatOpts = sizes;
            }

            var fieldName = displayTitle + (prod.options.length > 1 ? ' (' + (idx + 1) + ')' : '');

            var rawSizeTitle = optBlock.bundle_product_size_title;
            var cleanSizeTitle = rawSizeTitle && rawSizeTitle !== 'SIZE TITLE' ? rawSizeTitle : null;

            box.appendChild(
              buildGroup({
                label: displayTitle,
                fieldName: fieldName,
                required: true,
                type: 'select',
                optgroups: optgroups,
                options: flatOpts,
                sizeImage: optBlock.bundle_product_size_image || null,
                sizeTitle: cleanSizeTitle,
              })
            );
          });
        });
      }

      root.innerHTML = '';
      root.appendChild(box);
      root.style.display = 'block';
    }

    /* ─────────────────────────────
     FETCH
   ───────────────────────────── */
    function fetchOptions() {
      root.style.display = 'none';
      showSkeleton();

      fetch(API_BASE + '/' + productId + '/bundle-product-options', {
        method: 'GET',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          window.__fliteHideColor = false;
          console.log(data);
          if (data && data.code === 200 && data.body.bundle_options) {
            render(data.body);
            bindCartButton();
          }else if (data && data.code === 200 && data.body.custom_app_product) {
            window.__fliteHideColor = true;
            root.innerHTML = '';
            root.style.display = 'none';
            var pc = document.getElementsByClassName("productColor")[0];
            if (pc) {
              var colorSelect = pc.querySelector('select');
              var colorOptionCount = colorSelect
                ? colorSelect.querySelectorAll('option').length
                : 0;
              // Hide only when there's a single color value; show when multiple
              if (colorOptionCount <= 1) {
                pc.style.display = "none";
              } else {
                pc.style.display = "";
              }
            }
          } else {
            showApiError();
          }
        })
        .catch(function (err) {
          console.error('[FLITE] API error:', err);
          showApiError();
        });
    }
    document.addEventListener('DOMContentLoaded', function () {
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        // Disable any hidden/visible color option selects
        var allSelects = form.querySelectorAll('select, input[type="hidden"]');
        allSelects.forEach(function(el) {
          var name = (el.name || '').toLowerCase();
          if (name.includes('color')) {
            el.disabled = true;
          }
        });
      });
    });

    function showApiError() {
      root.innerHTML = '';
      root.style.display = 'none';
    }

    /* ─────────────────────────────
     CART INTEGRATION
  ───────────────────────────── */
    function collectAndAdd(form, addBtn) {
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) {
        console.error('[FLITE] Variant ID not found');
        return;
      }

      var variantId = variantInput.value;

      // Scope to THIS form specifically using the form[id] ↔ input[form="id"] relationship
      var formId = form.getAttribute('id');
      var qtyInput = null;

      if (formId) {
        // Input is associated via [form="formId"] attribute — lives outside the <form> tag in DOM
        qtyInput =
          document.querySelector('input.js-qty__num[form="' + formId + '"]') ||
          document.querySelector('[name="quantity"][form="' + formId + '"]');
      }

      // Fallback: input is physically inside the form
      if (!qtyInput) {
        qtyInput =
          form.querySelector('input.js-qty__num') ||
          form.querySelector('[name="quantity"]') ||
          form.querySelector('input[type="number"]');
      }

      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (quantity < 1) quantity = 1;
      var properties = collectProperties();

      // Also collect native form properties (e.g., player-number-150 select rendered
      // by product tag logic outside #custom-options-root, like VARIANT NUMBER OPTIONAL 150)
      form.querySelectorAll('[name^="properties["]').forEach(function (f) {
        if (root && root.contains(f)) return; // already handled by collectProperties()
        if (f.disabled) return;
        var m = (f.name || '').match(/^properties\[(.+)\]$/);
        if (m && f.value !== undefined && f.value.toString().trim() !== '') {
          properties[m[1]] = f.value.toString().trim();
        }
      });

      addBtn.disabled = true;
      addBtn.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties }),
      })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) throw json;
            return json;
          });
        })
        .then(function (item) {
          addBtn.disabled = false;
          addBtn.classList.remove('btn--loading');

          var evt = new CustomEvent('ajaxProduct:added', {
            detail: { product: item, addToCartBtn: addBtn },
            bubbles: true,
          });
          form.dispatchEvent(evt);
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: item, addToCartBtn: addBtn },
            })
          );
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.classList.remove('btn--loading');

          var old = form.querySelector('.errors');
          if (old) old.remove();

          var errDiv = document.createElement('div');
          errDiv.className = 'errors text-center';
          errDiv.textContent = (err && err.description) || 'Could not add to cart. Please try again.';
          form.appendChild(errDiv);
        });
    }

    function bindCartButton() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var addBtn = form.querySelector('[data-add-to-cart], button[name="add"]');
      if (!addBtn || addBtn.dataset.fliteBound) return;
      addBtn.dataset.fliteBound = '1';

      addBtn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!validateAll()) return;
          collectAndAdd(form, addBtn);
        },
        true
      );
    }

    /* ─────────────────────────────
     INIT
  ───────────────────────────── */
    function init() {
      fetchOptions();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('page:loaded', function () {
      bindCartButton();
    });
  })();